export enum AdjustmentType {
  Chooseitemsflow = "chooseItemsFlow",
  Finalizeflow = "finalizeFlow",
  Dynamicbundleadjustment = "dynamicBundleAdjustment",
  Merchantmanual = "merchantManual",
  Customerlabelupchargefee = "customerLabelUpchargeFee",
  Useitorloseit = "useItOrLoseIt",
  Leftoverexchangevalueincentive = "leftoverExchangeValueIncentive",
}
